import { render, staticRenderFns } from "./InspectionCriteria5a.vue?vue&type=template&id=916c2870&scoped=true"
import script from "./InspectionCriteria5a.vue?vue&type=script&lang=ts"
export * from "./InspectionCriteria5a.vue?vue&type=script&lang=ts"
import style0 from "./InspectionCriteria5a.vue?vue&type=style&index=0&id=916c2870&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916c2870",
  null
  
)

export default component.exports